
<!-- Admin doanh nghiệp && KH là Doanh Nghiệp -->
<div *ngIf="currentUserType == '1' || currentUserType == '2'">
    <app-analysis-report-enterprise></app-analysis-report-enterprise>
</div>

<!-- KH Cá nhân -->
<div *ngIf="currentUserType == '5' || currentUserType == '3' || currentUserType == '4' || currentUserType == '6'" >
    <app-analysis-report-customer></app-analysis-report-customer>
</div>
